import { SectionCard, SectionCardTitle, Slider } from "@/components";
import { slides } from "./consts";
import { Button } from "@/components/ui";
import { useState } from "react";

export const tabs = [
  { title: "Aquaculture Division", value: "1" },
  { title: "Poultry Division", value: "2" },
];

const Testimonials = () => {
  const [activeTab, setActiveTab] = useState("1");
  const [expanded, setExpanded] = useState<{ [key: number]: boolean }>({});
  const [isAutoSlide, setIsAutoSlide] = useState(true);

  const toggleExpand = (index: number) => {
    setExpanded((prev) => {
      const newExpanded = { ...prev, [index]: !prev[index] };
      const hasExpanded = Object.values(newExpanded).some(Boolean);
      setIsAutoSlide(!hasExpanded); // stop autoplay if expanded
      return newExpanded;
    });
  };

  // Helper to format trademarks correctly
    const formatTrademark = (text: string): string => {
  if (!text) return "";
  return text
    .replace(/®/g, "<sup>®</sup>")
    .replace(/™/g, "<sup>™</sup>")
    .replace(/\(R\)/gi, "<sup>®</sup>")
    .replace(/\(TM\)/gi, "<sup>™</sup>");
};


  return (
    <section className="bg-blue-900 lg:pb-[100px] relative">
      <div className="hidden lg:block h-[130px] w-[130px] bg-primary rounded-full absolute bottom-10 right-40 float-animation" />
      <SectionCard className="bg-[url('/img/testimonials_bg.png')] bg-no-repeat bg-left bg-contain flex flex-col items-center justify-center text-white">
        <SectionCardTitle className="lg:w-full text-center mb-10">
          Farmer Testimonials
        </SectionCardTitle>

        {/* Tabs */}
        <div className="flex gap-8 mb-10">
          {tabs.map((tab) => (
            <button
              key={tab.value}
              onClick={() => setActiveTab(tab.value)}
              className={`relative pb-2 text-base font-medium transition-colors cursor-pointer ${
                activeTab === tab.value
                  ? "text-white"
                  : "text-white/60 hover:text-white"
              }`}
            >
              {tab.title}
              <span
                className={`absolute left-0 -bottom-[1px] h-[2px] rounded transition-all duration-300 ${
                  activeTab === tab.value ? "w-full bg-white" : "w-0 bg-transparent"
                }`}
              />
            </button>
          ))}
        </div>

        {/* Slider */}
        <Slider
          key={activeTab}
          hideDots
          whiteNextPrevButton
          autoSlide={isAutoSlide}
          slides={
            activeTab === "1"
              ? // ✅ Aquaculture Division (video-based)
                 slides
                .filter((item) => item.category === "1") // filter only Aquaculture
                .slice(0, 3) .map((item) => (
                  <div
                    key={item.image}
                    className="w-full flex-shrink-0 lg:px-[90px] flex flex-col items-center justify-center mb-10"
                  >
                    <div className="flex flex-col items-center justify-center relative lg:pb-10">
                      <div className="hidden lg:block lg:h-[200px] lg:w-[530px] border-[7px] rounded-[40px] border-[#CEDFDE66] absolute -z-1 bottom-0" />
                      <div>
                        <img
                          src={item.image}
                          className="lg:!h-[350px] lg:!w-[700px] align-center mt-[10px] lg:mt-10"
                        />
                      </div>
                    </div>
                    <Button
                      asChild
                      variant="ghost"
                      className="border-b-1 border-b-white rounded-none hover:bg-transparent hover:text-primary hover:border-b-primary"
                    >
                      <a href={item.video} target="_blank" rel="noopener noreferrer">
                        Watch Video
                      </a>
                    </Button>
                  </div>
                ))
              : // ✅ Poultry Division (testimonial with expand/collapse)
                slides
                  .filter((d) => d.category === "2") // 👈 filter Poultry Division data
                  .map((data, index) => {
                    const isExpanded = expanded[index] || false;
                    const maxChars = 300;
                    const shortText =
                      data.testimonial && data.testimonial.length > maxChars
                        ? data.testimonial.substring(0, maxChars) + "..."
                        : data.testimonial || "";


                    return (
                      <div
                        key={index}
                        className="w-full flex-shrink-0 lg:px-[90px] flex items-center justify-center mb-10"
                      >
                        <div className="bg-[#F7FFFF] rounded-[20px] shadow-lg p-6 lg:p-10 max-w-[1000px] relative flex flex-col text-left">
                          <img
                            src={data.image || "/img/placeholder.jpg"}
                            alt={data.name || "Employee"}
                            className="w-25 h-25 rounded-full object-cover object-[50%_28%]"
                          />
                          <h3 className="text-2xl font-bold text-[#1D3A63] mt-5 mb-1">
                            {data.name}
                          </h3>
                          <p className="text-base text-gray-500 mb-6">
                            {data.designation}
                          </p>

                          <div className="text-gray-600 text-sm text-justify">
  <p
    dangerouslySetInnerHTML={{
      __html: isExpanded
        ? formatTrademark(data.testimonial || "")
        : formatTrademark(shortText || ""),
    }}
  />
  {data.testimonial && data.testimonial.length > maxChars && (
    <button
      onClick={() => toggleExpand(index)}
      className="text-blue-600 mt-2 font-medium cursor-pointer"
    >
      {isExpanded ? "Read less" : "Read more"}
    </button>
  )}
</div>



                          <div className="absolute top-6 right-6 text-[#FF9C9C] text-8xl font-serif">
                            &rdquo;
                          </div>
                        </div>
                      </div>
                    );
                  })
          }
        />
      </SectionCard>
    </section>
  );
};

export default Testimonials;
